import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "index";
var haberService = {
    kategoriTanimlama(link, baslik, menu, dil) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                link: link,
                baslik: baslik,
                menu: menu,
                dil: dil,
                serviceName: "haber",
                methodName: "kategoriTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriMenuList() {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                serviceName: "haber",
                methodName: "kategoriMenuList"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriList(durum) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                durum: durum,
                serviceName: "haber",
                methodName: "kategoriList"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriDurumGuncelle(hkategoriId,durum) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                hkategoriId: hkategoriId,
                durum: durum,
                serviceName: "haber",
                methodName: "kategoriDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriGuncelle(kategoriId, baslik, link, menu, dil) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                kategoriId: kategoriId,
                baslik: baslik,
                link: link,
                menu: menu,
                dil: dil,
                serviceName: "haber",
                methodName: "kategoriGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },


}

export default haberService

